import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface ParallelDimension {
  name: string;
  min: number;
  max: number;
}

interface ParallelChartProps {
  dimensions: ParallelDimension[];
  data: number[][];
  height?: number | string;
  loading?: boolean;
}

export function ParallelChart({ dimensions, data, height, loading }: ParallelChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    parallel: { left: '5%', right: '10%', bottom: 40, top: 20, parallelAxisDefault: { type: 'value' } },
    parallelAxis: dimensions.map((d) => ({ dim: dimensions.indexOf(d), name: d.name, min: d.min, max: d.max })),
    series: [{ type: 'parallel', data, lineStyle: { width: 2, opacity: 0.5 } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
